// 草稿
import { useSubscription } from "@apollo/react-hooks"
import { generateSubscription } from "Methods/query"
import { TableName } from "Types/table"

export function useFetchDraft(channelName: string) {
    let tableName: TableName
    let returnValue
    let where
    switch (channelName) {
        case '微信':
            tableName = "wechat_board"
            returnValue =
                "author { name hidden }" +
                "material { id status }" +
                "article_type { color_code hidden }" +
                "creator_info { nickname department { name color } role { role_name }}"
            where = {
                is_draft: {
                    _eq: true,
                },
            }
            break
        case '微博':
            tableName = "board"
            returnValue =
                "author { name hidden }" +
                "material { id status }" +
                "article_type { color_code hidden }" +
                "creator_info { nickname department { name color } role { role_name }}"
            where = {
                is_draft: {
                    _eq: true,
                },
                channel: {
                    name: {
                        _eq: "微博",
                    },
                },
            }
            break
        case '吃货':
            tableName = 'eat_board'
            returnValue =
                "eat_article_type { color_code hidden }" +
                "creator_info { nickname department { name color } role { role_name }}"
            where = {
                is_draft: {
                    _eq: true,
                },
                channel: {
                    name: {
                        _eq: "吃货",
                    },
                },
            }
            break
        case '果壳自然':
            tableName = "species_board"
            returnValue =
                "material { id status }" +
                "article_type { color_code hidden }" +
                "creator_info { nickname department { name color } role { role_name }}"
            where = {
                is_draft: {
                    _eq: true,
                },
                channel: {
                    name: {
                        _eq: "果壳自然",
                    },
                },
            }
            break
        default:
            tableName = "health_board"
            returnValue =
                "material { id status }" +
                "article_type { color_code hidden }" +
                "creator_info { nickname department { name color } role { role_name }}"
            where = {
                is_draft: {
                    _eq: true,
                },
                channel: {
                    name: {
                        _eq: "果壳病人",
                    },
                },
            }
            break

    }
    // if (channelName === '微信') {
    //     tableName = "wechat_board"
    //     returnValue =
    //         "author { name hidden }" +
    //         "material { id status }" +
    //         "article_type { color_code hidden }" +
    //         "creator_info { nickname department { name color } role { role_name }}"
    //     where = {
    //         is_draft: {
    //             _eq: true,
    //         },
    //     }
    // } else {
    //     tableName = "board"
    //     returnValue =
    //         "author { name hidden }" +
    //         "material { id status }" +
    //         "article_type { color_code hidden }" +
    //         "creator_info { nickname department { name color } role { role_name }}"
    //     where = {
    //         is_draft: {
    //             _eq: true,
    //         },
    //         channel: {
    //             name: {
    //                 _eq: "微博",
    //             },
    //         },
    //     }
    // }
    const draftMutation = generateSubscription(tableName, returnValue, '{created_at: desc}')
    const { data } = useSubscription(draftMutation, {
        variables: { where },
    })
    if (data && data[tableName]) {
        return data[tableName]
    }
    return []
}
